import gql from 'graphql-tag';

export const DELETE_MANUAL_VIEWERSHIP = gql`
  mutation DeleteManualViewership($id: ID!) {
    deleteManualViewership(id: $id) {
      success
      id
    }
  }
`;
